import { createBrowserRouter, Navigate } from "react-router-dom";
import AdminLayout from "../Layout/AdminLayout";
import ErrorOccurPage from "../pages/error/Error";
import NotFoundPage from "../pages/error/NotFoundError";
import InternalServerErrorPage from "../pages/error/InternalServerError";
import { ADMIN_ROUTES, PUBLIC_ROUTES } from "./routesConfig";
import { generateAdminRoutes, generatePublicRoutes } from "./routerGenerator";
import {
  AdminRoute,
  PublicRoute,
} from "../components/routing/protectedAndPublicRoute";
import AdminErrorBoundary from "../pages/error/AdminErrorBoundary";

const router = createBrowserRouter([
  // Root redirect
  {
    path: "/",
    element: <Navigate to="/admin/dashboard" replace />,
  },

  // Admin routes
  {
    path: "/admin",
    element: <AdminRoute />,
    children: [
      {
        element: <AdminLayout />,
        errorElement: <AdminErrorBoundary />,
        children: [
          ...generateAdminRoutes(ADMIN_ROUTES),
          {
            path: "orders",
            element: <Navigate to="/admin/orders/all" replace />,
          },
        ],
      },
    ],
  },

  // Public routes
  {
    element: <PublicRoute />,
    children: generatePublicRoutes(PUBLIC_ROUTES),
  },

  // Error pages
  {
    path: "/server-error",
    element: <InternalServerErrorPage />,
  },
  {
    path: "/error",
    element: <ErrorOccurPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);
export default router;
